@use '@/styles/tokens' as *;

/* Image lightbox (Figma 343:331852): a centered bounded modal over a dim scrim —
   not a full-bleed takeover. */
.mask {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-6);
  /* Not an --overlay-* token: those are rgba(0,0,0,·) at 40/60/80, and this scrim is
     neutral-950 at 55%. Kept as shipped so the queue drawer looks identical. */
  background: rgb(17 17 17 / 55%);
}
.backdrop {
  position: absolute;
  inset: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.card {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: min(720px, 90vw);
  max-height: 85vh;
  padding: var(--space-5);
  background: var(--surface-card);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-overlay);
}
/* Dark round dismiss pill (Figma 343:331855: Neutral/950 bg, white X) */
.close {
  position: absolute;
  top: var(--space-3);
  right: var(--space-3);
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: var(--space-1);
  border: none;
  border-radius: var(--radius-xl);
  background: $color-neutral-950;
  color: var(--text-inverse);
  cursor: pointer;

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}
.img {
  display: block;
  max-width: 100%;
  max-height: calc(85vh - var(--space-6) * 2);
  object-fit: contain;
}
